// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/dac-web-ui/src/ui-components/toolbox/toolBox.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toolboxIcon {
	font-size: 25px;
}

#toolboxContainer{
	display: flex;
	position: fixed;
	top:0;
	left: 0;
	right: 0;
	width: 100%;
	justify-content: center;
	align-items: center;
}

#toolbox {
	display: flex;
}

.toolboxButton {
    background-color: white;
}

.toolboxButton:hover {
	cursor: pointer;
	background-color: whitesmoke;
}

.toolboxLine {
    min-height: 3vh;
    border: 1px solid #00000045;
    margin-right: 0.25vw;
    margin-left: 0.25vw;
}

#utility2DContainer {
	display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    position: fixed;
    left: 50%;
    top: 6vh;
    transform: translate(-50%, 0);
    background-color: white;
    padding: 0.15vw;
    border-radius: 10px;
    min-width: 5vw;
}

.showingGroup {
	background-color: #e5ffe8;
}`, "",{"version":3,"sources":["webpack://./src/project/css/toolbox.module.css"],"names":[],"mappings":"AAEA;CACC,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,eAAe;CACf,KAAK;CACL,OAAO;CACP,QAAQ;CACR,WAAW;CACX,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;CACC,eAAe;CACf,4BAA4B;AAC7B;;AAEA;IACI,eAAe;IACf,2BAA2B;IAC3B,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;CACC,aAAa;IACV,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,SAAS;IACT,QAAQ;IACR,6BAA6B;IAC7B,uBAAuB;IACvB,eAAe;IACf,mBAAmB;IACnB,cAAc;AAClB;;AAEA;CACC,yBAAyB;AAC1B","sourcesContent":["@import url(\"~dac-web-ui/src/ui-components/toolbox/toolBox.css\");\r\n\r\n.toolboxIcon {\r\n\tfont-size: 25px;\r\n}\r\n\r\n#toolboxContainer{\r\n\tdisplay: flex;\r\n\tposition: fixed;\r\n\ttop:0;\r\n\tleft: 0;\r\n\tright: 0;\r\n\twidth: 100%;\r\n\tjustify-content: center;\r\n\talign-items: center;\r\n}\r\n\r\n#toolbox {\r\n\tdisplay: flex;\r\n}\r\n\r\n.toolboxButton {\r\n    background-color: white;\r\n}\r\n\r\n.toolboxButton:hover {\r\n\tcursor: pointer;\r\n\tbackground-color: whitesmoke;\r\n}\r\n\r\n.toolboxLine {\r\n    min-height: 3vh;\r\n    border: 1px solid #00000045;\r\n    margin-right: 0.25vw;\r\n    margin-left: 0.25vw;\r\n}\r\n\r\n#utility2DContainer {\r\n\tdisplay: flex;\r\n    flex-direction: row;\r\n    justify-content: center;\r\n    align-items: center;\r\n    position: fixed;\r\n    left: 50%;\r\n    top: 6vh;\r\n    transform: translate(-50%, 0);\r\n    background-color: white;\r\n    padding: 0.15vw;\r\n    border-radius: 10px;\r\n    min-width: 5vw;\r\n}\r\n\r\n.showingGroup {\r\n\tbackground-color: #e5ffe8;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
